import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';
import { ServicesRpcService } from '@shared/services';
import { RouterService } from '@shared/services/router.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MainRoute } from '../../../../../../bar/routes/main-routes-config';
import { SidebarService } from '../../../../../services/sidebar.service';

@Component({
  selector: 'nav-item',
  templateUrl: './nav-item.component.html',
  styleUrls: ['./nav-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavItemComponent implements OnInit {
  @Input() item: MainRoute;
  @Input() visible: boolean = false;
  @Input() child: boolean = false;
  @Input() minimized: boolean = false;
  @Input() showTitle: boolean = false;
  active$: Observable<boolean>;

  constructor(private routerService: RouterService, private services: ServicesRpcService, private sidebarService: SidebarService) {}

  ngOnInit() {
    this.active$ = this.routerService.active$.pipe(map((id) => id && id === this.item?.data?.id));
  }

  @HostBinding('class.minimized') get _minimized() {
    return this.minimized;
  }

  shutdown() {
    this.services.invoke('app.close');
  }

  routerLink(path: string) {
    this.sidebarService.clearActiveNode();
    this.routerService.navigateByUrl(path);
  }
}
